import LeetcodeFeatured from './Leetcode.Featured';

export default {
  LeetcodeFeatured,
}